
import React, { Component } from 'react';
import { Col, Button, FormGroup } from 'reactstrap';
import { connect } from "react-redux";
import ErrorGif from '../../../../../../Assets/images/Error.gif';
import { GetBuildingsList,SaveZoneDetailsforclient,GetZonesList } from '../../../../../../action/ZonesAction';
import { GetBuildingsDetailsList } from '../../../../../../action/HolidaysAction';
import { closeModalPopUp } from '../../../../../../action/modalStateAction';

let error_msg = "";

class AddZoneForm1 extends Component {

    componentWillMount() {
        this.props.GetBuildingsList();
        this.props.GetBuildingsDetailsList();
    }

    constructor(props) {
        super(props);
        this.state = {
            error:false
        };
       this.nextForm = this.nextForm.bind(this);
       this.CloseModal = this.CloseModal.bind(this);
      }


    nextForm()  {
        this.props.closeModalPopUp("open");
        const New_Zone_Name = this.refs.New_Zone_Name.value; // New Zone name  from input
        error_msg = "";
        if(New_Zone_Name===""){
            this.setState({
                error: true
            });
            return;
        }
        if(this.props.getResponse !== undefined && this.props.getResponse.ZonesList !== null){
            let lstZones = this.props.getResponse.ZonesList;
            if(lstZones !== undefined && lstZones.length > 0){
                lstZones = lstZones.filter(function(item){
                return New_Zone_Name === item.zoneName
                });
                if(lstZones != null && lstZones.length > 0){
                    error_msg = 'Error: Duplicate Zone Name.';
                    this.setState({
                        error: true                        
                    });

                    return;
                }
            }
        }

        let Building_ID;
        var selectedoption =this.refs.Building_in_Select_input.options.selectedIndex; 
        if(this.refs.Building_in_Select_input.options[selectedoption] !== undefined)
        Building_ID= this.refs.Building_in_Select_input.options[selectedoption].id; // fetching Building ID from the select input
        else{
            this.setState({
                error: true
            });
            return;
        }

        var selected_Building_Name = this.refs.Building_in_Select_input.value;              // Building Name from select option

          var data = {
             "Zone_Name"  : New_Zone_Name,
             "Building_ID"  : Building_ID,
             "Building_Name"  : selected_Building_Name,
             "FormDisplay"  : false
          }
            this.props.SaveZoneDetailsforclient(data);
    }

    CloseModal()  {
         this.props.closeModalPopUp("close");
    }
   
    render(getResponse,ClientSideZoneState, Buildings_List_Response,getLabels) {

       // var	CloseModal	=	this.props.CloseModal;
        let label = this.props.getLabels;
        
        let modal_form_1 , Buildings_in_Select_input = null, lZoneName ="", lBuildingId;

        if (this.props.Response_of_BuildingsCall.BuildingsDetailsList !== undefined) {
                Buildings_in_Select_input = this.props.Response_of_BuildingsCall.BuildingsDetailsList.sort((a,b) => (a.siteName.toLowerCase() > b.siteName.toLowerCase())).map(el => (
                     <option id={el.siteID} key={el.siteID}>{el.siteName}</option>
                ));
            }

            if(this.props.ClientSideZoneState !== undefined && this.props.ClientSideZoneState !== null){
                lZoneName = this.props.ClientSideZoneState.Zone_Name;
                lBuildingId = this.props.ClientSideZoneState.Building_Name;
            }

            // validations
            if(this.state.error){
                 var errormsg =   <p  className="error_msg">
                 <img src={ErrorGif} alt="Trane Logo" /> 

                 {error_msg === "" ? ( label['CheckTemperatureAdjustment.Text'] !== undefined ? label['CheckTemperatureAdjustment.Text'] : "Error: You left necessary fields blank or entered invalid values.") : error_msg}
                 </p> 
               }

            /* Form 1 modal Content, this form has new zone name and 
               list of Building fields. */         
            
                 modal_form_1 =    <div>
                                     {errormsg}

                                    <h4 className="Modal_form_title">{label['TenantZones.AddZone.Text'] !== undefined ? label['TenantZones.AddZone.Text'] : "Add New Zone"}</h4>
                                    <div className="Modal_form_group ">
                                        <label className="Modal_label">{label['TenantZones.Name.Text'] !== undefined ? label['TenantZones.Name.Text'] : "Name"}</label>
                                        <input ref='New_Zone_Name' defaultValue={lZoneName} className="Modal_input_regular default-input" maxLength="200"/>
                                    </div>

                                    <div className="Modal_form_group ">
                                        <label className="Modal_label">{label['TenantZones.Building.Text'] !== undefined ? label['TenantZones.Building.Text'] : "Building"}</label>
                                        <select ref='Building_in_Select_input' defaultValue={lBuildingId} className="Modal_input_regular"   >
                                            {Buildings_in_Select_input}
                                        </select>
                                    </div>

                                    {/* onChange={()=>{this.changeMemberType();}} */}
                                    <FormGroup row >
                                        <Col sm={{ size: 12 }}>
                                            <Button className="btn-gray btn-md"  onClick={this.CloseModal} > {label['TenantZones.Cancel.Text'] !== undefined ? label['TenantZones.Cancel.Text'] : "Cancel"} </Button>
                                            {/* <Button className="btn-black btn-md ChangeLimits_Applybtn" onClick={this.nextForm}  onClick={ this.props.nextForm } >Next {">"}</Button> */}
                                            <Button className="btn-success btn-md"  onClick={this.nextForm}    >{label['TenantZones.btnNextSelection.Text'] !== undefined ? label['TenantZones.btnNextSelection.Text'] : "Next >"}</Button>
                                           
                                        </Col>
                                    </FormGroup>
                                </div>
        return (
            <div>
            {modal_form_1}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        Buildings_List_Response: state.buildingsRootReducer,
        Response_of_BuildingsCall: state.BuildingDetailsReducer,
        getLabels: state.CulturalLabelsRootReducer.LabelsBasedOnPreference,
        ClientSideZoneState: state.zonesRootReducer.ClientSideZonesData,
        getResponse: state.zonesRootReducer
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetBuildingsList: () => dispatch(GetBuildingsList()),
        GetBuildingsDetailsList: () => dispatch(GetBuildingsDetailsList()),
        SaveZoneDetailsforclient: DataForState => dispatch(SaveZoneDetailsforclient(DataForState)),
        closeModalPopUp: (data) => dispatch(closeModalPopUp(data)),
        GetZonesList: () => dispatch(GetZonesList())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddZoneForm1);
            



